import React, { useState, useEffect, useRef } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';

import {
  StyledTBody,
  StyledTable,
  StyledTableHead,
  OwnerColumnHeader,
  LabelColumnHeader,
  TitleColumnHeader,
  PhotoColumnHeader,
  OptionsHeader,
  OptionsWrapper,
} from 'components/event/List';

import EventSearchInput from 'components/team/EventSearchInput';
import NoItems, { ContentType } from 'components/NoItems';
import ListItem from './ArchiveListItem';

import { onSearchTermChange, onCancelSearch } from 'utils/eventSearchHelper';
import { redirectToEventDash } from 'utils/redirectHelper';
import { getDateFormat } from 'utils/teamHelper';

const PastEventList = ({
  team,
  events,
  onRestoreClick,
  onDeleteClick,
  onDuplicateClick,
  onViewClick,
  searchTeamEvents,
  clearTeamEventsSearchResults,
  teamEventSearchResults,
  history,
  filter,
  isLoading,
  hasMoreEvents,
  loadNextEvents,
}) => {
  const tableRef = useRef();
  const [tableHeaderTop, setTableHeaderTop] = useState(0);

  useEffect(() => {
    setTableHeaderTop(tableRef.current.getBoundingClientRect().top);
  }, []);

  const [searchTerm, setSearchTerm] = useState('');

  const onItemClick = redirectToEventDash.bind(null, history);

  const eventSearchNode = (
    <EventSearchInput
      dateFormat={getDateFormat(team)}
      onChange={onSearchTermChange.bind(
        null,
        setSearchTerm,
        searchTeamEvents,
        clearTeamEventsSearchResults,
        filter,
      )}
      onResultClick={onItemClick}
      onCancel={onCancelSearch.bind(
        null,
        setSearchTerm,
        clearTeamEventsSearchResults,
      )}
      value={searchTerm}
      results={teamEventSearchResults}
    />
  );

  const rows =
    events.length >= 1
      ? events.map((evt) => (
          <ListItem
            key={`past-evt-table-row-${evt._id}`}
            event={evt}
            dateFormat={getDateFormat(team)}
            {...{
              onDuplicateClick,
              onRestoreClick,
              onDeleteClick,
              onViewClick,
            }}
          />
        ))
      : null;

  return (
    <InfiniteScroll
      dataLength={events.length}
      next={loadNextEvents}
      hasMore={hasMoreEvents}
      loader={<h4>Loading more items...</h4>}
      style={{ overflow: 'unset' }}
    >
      <StyledTable>
        <StyledTableHead stickytop={`${tableHeaderTop}px`} ref={tableRef}>
          <tr>
            <PhotoColumnHeader>Event</PhotoColumnHeader>
            <TitleColumnHeader></TitleColumnHeader>
            <LabelColumnHeader className="d-none d-lg-table-cell">
              Labels
            </LabelColumnHeader>
            <OwnerColumnHeader className="d-none d-lg-table-cell">
              Owner
            </OwnerColumnHeader>
            <OptionsHeader>
              <OptionsWrapper>{eventSearchNode}</OptionsWrapper>
            </OptionsHeader>
          </tr>
        </StyledTableHead>
        <StyledTBody>
          {!rows && isLoading && (
            <NoItems type={ContentType.Event} isLoading={isLoading} />
          )}

          {!rows && !isLoading ? (
            <NoItems
              title="You don't have any past events!"
              subTitle="Check back after loadout."
              isLoading={isLoading}
              type={ContentType.Event}
            />
          ) : (
            rows
          )}
        </StyledTBody>
      </StyledTable>
    </InfiniteScroll>
  );
};

export default PastEventList;
